import React, {lazy, Suspense} from 'react'

const EcclesiasticPageLazy = lazy(() =>
    import('./EcclesiasticPage')
)

const EcclesiasticPage = props => (
    <Suspense fallback={null}>
        <EcclesiasticPageLazy {...props} />
    </Suspense>
)

export default EcclesiasticPage
